import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the section editor a "Sections" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/content/sections')({
  staticData: { crumb: 'common:nav.sections' },
  component: Outlet,
});
